import { createAction } from '../helpers';
export const setCartWidgetVisibility = createAction('[widget] set visibility');
export const setPricesCartWidget = createAction('[widget] set prices');